export default __webpack_public_path__ + "static/media/best-unknown-national-parks-734x490.533206f1.jpg";